<script>
    import FormInputMixin from './Input.vue';
    export default {
        mixins: [FormInputMixin],
        props: {
            initialOptions: {
                type: [Object, Array],
                required: true
            },
            fetchOptionsEvent: {
                type: String,
                required: false
            },
        },
        data() {
            return {
                options: this.initialOptions
            }
        },
        created() {
            if (this.fetchOptionsEvent) {
                EventHandler.listen(this.fetchOptionsEvent, this.updateOptions);
            }
            if (this.updateEvent) {
                EventHandler.listen(this.updateEvent, this.change);
            }
        },
        mounted() {
            this.initialise();
        },
        methods: {
            updateOptions(data) {
                this.options = data;
                this.initialise();
            },
            initialise() {
                if (
                    (this.initialValue === '') &&
                    this.placeholder === undefined &&
                    this.options.length > 0
                ) {
                    this.update(this.options[0].value);
                } else {
                    this.update(this.initialValue);
                }
            },
            isSelected(value) {
                if (!this.value) {
                    return false;
                }
                return this.value.toString() === value.toString();
            },
            change(value) {
                this.update(value);
                if (this.fireEvent) {
                    EventHandler.fire(this.fireEvent, value);
                }
            }
        }
    }
</script>